import { x as kt, y as _t, z as St, A as nt, B as Rt, C as xt, D as Tt, E as Nt } from "./index-E8vB_04G.js";
var it = { exports: {} }, st = { exports: {} }, ae = { exports: {} }, Et = xe;
function xe(h, p) {
  typeof h == "string" && (p = h, h = void 0);
  var f = [];
  function u(s) {
    if (typeof s != "string") {
      var e = l();
      if (xe.verbose && console.log("codegen: " + e), e = "return " + e, s) {
        for (var n = Object.keys(s), r = new Array(n.length + 1), t = new Array(n.length), o = 0; o < n.length; )
          r[o] = n[o], t[o] = s[n[o++]];
        return r[o] = e, Function.apply(null, r).apply(null, t);
      }
      return Function(e)();
    }
    for (var i = new Array(arguments.length - 1), c = 0; c < i.length; )
      i[c] = arguments[++c];
    if (c = 0, s = s.replace(/%([%dfijs])/g, function(y, m) {
      var x = i[c++];
      switch (m) {
        case "d":
        case "f":
          return String(Number(x));
        case "i":
          return String(Math.floor(x));
        case "j":
          return JSON.stringify(x);
        case "s":
          return String(x);
      }
      return "%";
    }), c !== i.length)
      throw Error("parameter count mismatch");
    return f.push(s), u;
  }
  function l(s) {
    return "function " + (s || p || "") + "(" + (h && h.join(",") || "") + `){
  ` + f.join(`
  `) + `
}`;
  }
  return u.toString = l, u;
}
xe.verbose = !1;
var It = ee, Ft = _t, qt = kt, ue = qt("fs");
function ee(h, p, f) {
  return typeof p == "function" ? (f = p, p = {}) : p || (p = {}), f ? !p.xhr && ue && ue.readFile ? ue.readFile(h, function(l, s) {
    return l && typeof XMLHttpRequest < "u" ? ee.xhr(h, p, f) : l ? f(l) : f(null, p.binary ? s : s.toString("utf8"));
  }) : ee.xhr(h, p, f) : Ft(ee, this, h, p);
}
ee.xhr = function(p, f, u) {
  var l = new XMLHttpRequest();
  l.onreadystatechange = function() {
    if (l.readyState === 4) {
      if (l.status !== 0 && l.status !== 200)
        return u(Error("status " + l.status));
      if (f.binary) {
        var e = l.response;
        if (!e) {
          e = [];
          for (var n = 0; n < l.responseText.length; ++n)
            e.push(l.responseText.charCodeAt(n) & 255);
        }
        return u(null, typeof Uint8Array < "u" ? new Uint8Array(e) : e);
      }
      return u(null, l.responseText);
    }
  }, f.binary && ("overrideMimeType" in l && l.overrideMimeType("text/plain; charset=x-user-defined"), l.responseType = "arraybuffer"), l.open("GET", p), l.send();
};
var ot = {};
(function(h) {
  var p = h, f = (
    /**
     * Tests if the specified path is absolute.
     * @param {string} path Path to test
     * @returns {boolean} `true` if path is absolute
     */
    p.isAbsolute = function(s) {
      return /^(?:\/|\w+:)/.test(s);
    }
  ), u = (
    /**
     * Normalizes the specified path.
     * @param {string} path Path to normalize
     * @returns {string} Normalized path
     */
    p.normalize = function(s) {
      s = s.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
      var e = s.split("/"), n = f(s), r = "";
      n && (r = e.shift() + "/");
      for (var t = 0; t < e.length; )
        e[t] === ".." ? t > 0 && e[t - 1] !== ".." ? e.splice(--t, 2) : n ? e.splice(t, 1) : ++t : e[t] === "." ? e.splice(t, 1) : ++t;
      return r + e.join("/");
    }
  );
  p.resolve = function(s, e, n) {
    return n || (e = u(e)), f(e) ? e : (n || (s = u(s)), (s = s.replace(/(?:\/|^)[^/]+$/, "")).length ? u(s + "/" + e) : e);
  };
})(ot);
var fe = {}, Ce;
function Q() {
  return Ce || (Ce = 1, function(h) {
    var p = h, f = D(), u = [
      "double",
      // 0
      "float",
      // 1
      "int32",
      // 2
      "uint32",
      // 3
      "sint32",
      // 4
      "fixed32",
      // 5
      "sfixed32",
      // 6
      "int64",
      // 7
      "uint64",
      // 8
      "sint64",
      // 9
      "fixed64",
      // 10
      "sfixed64",
      // 11
      "bool",
      // 12
      "string",
      // 13
      "bytes"
      // 14
    ];
    function l(s, e) {
      var n = 0, r = {};
      for (e |= 0; n < s.length; )
        r[u[n + e]] = s[n++];
      return r;
    }
    p.basic = l([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2,
      /* bytes    */
      2
    ]), p.defaults = l([
      /* double   */
      0,
      /* float    */
      0,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      0,
      /* sfixed32 */
      0,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      0,
      /* sfixed64 */
      0,
      /* bool     */
      !1,
      /* string   */
      "",
      /* bytes    */
      f.emptyArray,
      /* message  */
      null
    ]), p.long = l([
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1
    ], 7), p.mapKey = l([
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2
    ], 2), p.packed = l([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0
    ]);
  }(fe)), fe;
}
var le, Be;
function X() {
  if (Be)
    return le;
  Be = 1, le = e;
  var h = Y();
  ((e.prototype = Object.create(h.prototype)).constructor = e).className = "Field";
  var p = G(), f = Q(), u = D(), l, s = /^required|optional|repeated$/;
  e.fromJSON = function(r, t) {
    return new e(r, t.id, t.type, t.rule, t.extend, t.options, t.comment);
  };
  function e(n, r, t, o, i, c, a) {
    if (u.isObject(o) ? (a = i, c = o, o = i = void 0) : u.isObject(i) && (a = c, c = i, i = void 0), h.call(this, n, c), !u.isInteger(r) || r < 0)
      throw TypeError("id must be a non-negative integer");
    if (!u.isString(t))
      throw TypeError("type must be a string");
    if (o !== void 0 && !s.test(o = o.toString().toLowerCase()))
      throw TypeError("rule must be a string rule");
    if (i !== void 0 && !u.isString(i))
      throw TypeError("extend must be a string");
    o === "proto3_optional" && (o = "optional"), this.rule = o && o !== "optional" ? o : void 0, this.type = t, this.id = r, this.extend = i || void 0, this.required = o === "required", this.optional = !this.required, this.repeated = o === "repeated", this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = u.Long ? f.long[t] !== void 0 : (
      /* istanbul ignore next */
      !1
    ), this.bytes = t === "bytes", this.resolvedType = null, this.extensionField = null, this.declaringField = null, this._packed = null, this.comment = a;
  }
  return Object.defineProperty(e.prototype, "packed", {
    get: function() {
      return this._packed === null && (this._packed = this.getOption("packed") !== !1), this._packed;
    }
  }), e.prototype.setOption = function(r, t, o) {
    return r === "packed" && (this._packed = null), h.prototype.setOption.call(this, r, t, o);
  }, e.prototype.toJSON = function(r) {
    var t = r ? !!r.keepComments : !1;
    return u.toObject([
      "rule",
      this.rule !== "optional" && this.rule || void 0,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      t ? this.comment : void 0
    ]);
  }, e.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if ((this.typeDefault = f.defaults[this.type]) === void 0 ? (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof l ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]) : this.options && this.options.proto3_optional && (this.typeDefault = null), this.options && this.options.default != null && (this.typeDefault = this.options.default, this.resolvedType instanceof p && typeof this.typeDefault == "string" && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && ((this.options.packed === !0 || this.options.packed !== void 0 && this.resolvedType && !(this.resolvedType instanceof p)) && delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long)
      this.typeDefault = u.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u"), Object.freeze && Object.freeze(this.typeDefault);
    else if (this.bytes && typeof this.typeDefault == "string") {
      var r;
      u.base64.test(this.typeDefault) ? u.base64.decode(this.typeDefault, r = u.newBuffer(u.base64.length(this.typeDefault)), 0) : u.utf8.write(this.typeDefault, r = u.newBuffer(u.utf8.length(this.typeDefault)), 0), this.typeDefault = r;
    }
    return this.map ? this.defaultValue = u.emptyObject : this.repeated ? this.defaultValue = u.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof l && (this.parent.ctor.prototype[this.name] = this.defaultValue), h.prototype.resolve.call(this);
  }, e.d = function(r, t, o, i) {
    return typeof t == "function" ? t = u.decorateType(t).name : t && typeof t == "object" && (t = u.decorateEnum(t).name), function(a, y) {
      u.decorateType(a.constructor).add(new e(y, r, t, o, { default: i }));
    };
  }, e._configure = function(r) {
    l = r;
  }, le;
}
var de, Pe;
function te() {
  if (Pe)
    return de;
  Pe = 1, de = u;
  var h = Y();
  ((u.prototype = Object.create(h.prototype)).constructor = u).className = "OneOf";
  var p = X(), f = D();
  function u(s, e, n, r) {
    if (Array.isArray(e) || (n = e, e = void 0), h.call(this, s, n), !(e === void 0 || Array.isArray(e)))
      throw TypeError("fieldNames must be an Array");
    this.oneof = e || [], this.fieldsArray = [], this.comment = r;
  }
  u.fromJSON = function(e, n) {
    return new u(e, n.oneof, n.options, n.comment);
  }, u.prototype.toJSON = function(e) {
    var n = e ? !!e.keepComments : !1;
    return f.toObject([
      "options",
      this.options,
      "oneof",
      this.oneof,
      "comment",
      n ? this.comment : void 0
    ]);
  };
  function l(s) {
    if (s.parent)
      for (var e = 0; e < s.fieldsArray.length; ++e)
        s.fieldsArray[e].parent || s.parent.add(s.fieldsArray[e]);
  }
  return u.prototype.add = function(e) {
    if (!(e instanceof p))
      throw TypeError("field must be a Field");
    return e.parent && e.parent !== this.parent && e.parent.remove(e), this.oneof.push(e.name), this.fieldsArray.push(e), e.partOf = this, l(this), this;
  }, u.prototype.remove = function(e) {
    if (!(e instanceof p))
      throw TypeError("field must be a Field");
    var n = this.fieldsArray.indexOf(e);
    if (n < 0)
      throw Error(e + " is not a member of " + this);
    return this.fieldsArray.splice(n, 1), n = this.oneof.indexOf(e.name), n > -1 && this.oneof.splice(n, 1), e.partOf = null, this;
  }, u.prototype.onAdd = function(e) {
    h.prototype.onAdd.call(this, e);
    for (var n = this, r = 0; r < this.oneof.length; ++r) {
      var t = e.get(this.oneof[r]);
      t && !t.partOf && (t.partOf = n, n.fieldsArray.push(t));
    }
    l(this);
  }, u.prototype.onRemove = function(e) {
    for (var n = 0, r; n < this.fieldsArray.length; ++n)
      (r = this.fieldsArray[n]).parent && r.parent.remove(r);
    h.prototype.onRemove.call(this, e);
  }, u.d = function() {
    for (var e = new Array(arguments.length), n = 0; n < arguments.length; )
      e[n] = arguments[n++];
    return function(t, o) {
      f.decorateType(t.constructor).add(new u(o, e)), Object.defineProperty(t, o, {
        get: f.oneOfGetter(e),
        set: f.oneOfSetter(e)
      });
    };
  }, de;
}
var ce, Ve;
function re() {
  if (Ve)
    return ce;
  Ve = 1, ce = r;
  var h = Y();
  ((r.prototype = Object.create(h.prototype)).constructor = r).className = "Namespace";
  var p = X(), f = D(), u = te(), l, s, e;
  r.fromJSON = function(i, c) {
    return new r(i, c.options).addJSON(c.nested);
  };
  function n(o, i) {
    if (o && o.length) {
      for (var c = {}, a = 0; a < o.length; ++a)
        c[o[a].name] = o[a].toJSON(i);
      return c;
    }
  }
  r.arrayToJSON = n, r.isReservedId = function(i, c) {
    if (i) {
      for (var a = 0; a < i.length; ++a)
        if (typeof i[a] != "string" && i[a][0] <= c && i[a][1] > c)
          return !0;
    }
    return !1;
  }, r.isReservedName = function(i, c) {
    if (i) {
      for (var a = 0; a < i.length; ++a)
        if (i[a] === c)
          return !0;
    }
    return !1;
  };
  function r(o, i) {
    h.call(this, o, i), this.nested = void 0, this._nestedArray = null;
  }
  function t(o) {
    return o._nestedArray = null, o;
  }
  return Object.defineProperty(r.prototype, "nestedArray", {
    get: function() {
      return this._nestedArray || (this._nestedArray = f.toArray(this.nested));
    }
  }), r.prototype.toJSON = function(i) {
    return f.toObject([
      "options",
      this.options,
      "nested",
      n(this.nestedArray, i)
    ]);
  }, r.prototype.addJSON = function(i) {
    var c = this;
    if (i)
      for (var a = Object.keys(i), y = 0, m; y < a.length; ++y)
        m = i[a[y]], c.add(
          // most to least likely
          (m.fields !== void 0 ? l.fromJSON : m.values !== void 0 ? e.fromJSON : m.methods !== void 0 ? s.fromJSON : m.id !== void 0 ? p.fromJSON : r.fromJSON)(a[y], m)
        );
    return this;
  }, r.prototype.get = function(i) {
    return this.nested && this.nested[i] || null;
  }, r.prototype.getEnum = function(i) {
    if (this.nested && this.nested[i] instanceof e)
      return this.nested[i].values;
    throw Error("no such enum: " + i);
  }, r.prototype.add = function(i) {
    if (!(i instanceof p && i.extend !== void 0 || i instanceof l || i instanceof u || i instanceof e || i instanceof s || i instanceof r))
      throw TypeError("object must be a valid nested object");
    if (!this.nested)
      this.nested = {};
    else {
      var c = this.get(i.name);
      if (c)
        if (c instanceof r && i instanceof r && !(c instanceof l || c instanceof s)) {
          for (var a = c.nestedArray, y = 0; y < a.length; ++y)
            i.add(a[y]);
          this.remove(c), this.nested || (this.nested = {}), i.setOptions(c.options, !0);
        } else
          throw Error("duplicate name '" + i.name + "' in " + this);
    }
    return this.nested[i.name] = i, i.onAdd(this), t(this);
  }, r.prototype.remove = function(i) {
    if (!(i instanceof h))
      throw TypeError("object must be a ReflectionObject");
    if (i.parent !== this)
      throw Error(i + " is not a member of " + this);
    return delete this.nested[i.name], Object.keys(this.nested).length || (this.nested = void 0), i.onRemove(this), t(this);
  }, r.prototype.define = function(i, c) {
    if (f.isString(i))
      i = i.split(".");
    else if (!Array.isArray(i))
      throw TypeError("illegal path");
    if (i && i.length && i[0] === "")
      throw Error("path must be relative");
    for (var a = this; i.length > 0; ) {
      var y = i.shift();
      if (a.nested && a.nested[y]) {
        if (a = a.nested[y], !(a instanceof r))
          throw Error("path conflicts with non-namespace objects");
      } else
        a.add(a = new r(y));
    }
    return c && a.addJSON(c), a;
  }, r.prototype.resolveAll = function() {
    for (var i = this.nestedArray, c = 0; c < i.length; )
      i[c] instanceof r ? i[c++].resolveAll() : i[c++].resolve();
    return this.resolve();
  }, r.prototype.lookup = function(i, c, a) {
    if (typeof c == "boolean" ? (a = c, c = void 0) : c && !Array.isArray(c) && (c = [c]), f.isString(i) && i.length) {
      if (i === ".")
        return this.root;
      i = i.split(".");
    } else if (!i.length)
      return this;
    if (i[0] === "")
      return this.root.lookup(i.slice(1), c);
    var y = this.get(i[0]);
    if (y) {
      if (i.length === 1) {
        if (!c || c.indexOf(y.constructor) > -1)
          return y;
      } else if (y instanceof r && (y = y.lookup(i.slice(1), c, !0)))
        return y;
    } else
      for (var m = 0; m < this.nestedArray.length; ++m)
        if (this._nestedArray[m] instanceof r && (y = this._nestedArray[m].lookup(i, c, !0)))
          return y;
    return this.parent === null || a ? null : this.parent.lookup(i, c);
  }, r.prototype.lookupType = function(i) {
    var c = this.lookup(i, [l]);
    if (!c)
      throw Error("no such type: " + i);
    return c;
  }, r.prototype.lookupEnum = function(i) {
    var c = this.lookup(i, [e]);
    if (!c)
      throw Error("no such Enum '" + i + "' in " + this);
    return c;
  }, r.prototype.lookupTypeOrEnum = function(i) {
    var c = this.lookup(i, [l, e]);
    if (!c)
      throw Error("no such Type or Enum '" + i + "' in " + this);
    return c;
  }, r.prototype.lookupService = function(i) {
    var c = this.lookup(i, [s]);
    if (!c)
      throw Error("no such Service '" + i + "' in " + this);
    return c;
  }, r._configure = function(o, i, c) {
    l = o, s = i, e = c;
  }, ce;
}
var he, Me;
function Te() {
  if (Me)
    return he;
  Me = 1, he = u;
  var h = X();
  ((u.prototype = Object.create(h.prototype)).constructor = u).className = "MapField";
  var p = Q(), f = D();
  function u(l, s, e, n, r, t) {
    if (h.call(this, l, s, n, void 0, void 0, r, t), !f.isString(e))
      throw TypeError("keyType must be a string");
    this.keyType = e, this.resolvedKeyType = null, this.map = !0;
  }
  return u.fromJSON = function(s, e) {
    return new u(s, e.id, e.keyType, e.type, e.options, e.comment);
  }, u.prototype.toJSON = function(s) {
    var e = s ? !!s.keepComments : !1;
    return f.toObject([
      "keyType",
      this.keyType,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      e ? this.comment : void 0
    ]);
  }, u.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if (p.mapKey[this.keyType] === void 0)
      throw Error("invalid key type: " + this.keyType);
    return h.prototype.resolve.call(this);
  }, u.d = function(s, e, n) {
    return typeof n == "function" ? n = f.decorateType(n).name : n && typeof n == "object" && (n = f.decorateEnum(n).name), function(t, o) {
      f.decorateType(t.constructor).add(new u(o, s, e, n));
    };
  }, he;
}
var pe, Le;
function Ne() {
  if (Le)
    return pe;
  Le = 1, pe = f;
  var h = Y();
  ((f.prototype = Object.create(h.prototype)).constructor = f).className = "Method";
  var p = D();
  function f(u, l, s, e, n, r, t, o, i) {
    if (p.isObject(n) ? (t = n, n = r = void 0) : p.isObject(r) && (t = r, r = void 0), !(l === void 0 || p.isString(l)))
      throw TypeError("type must be a string");
    if (!p.isString(s))
      throw TypeError("requestType must be a string");
    if (!p.isString(e))
      throw TypeError("responseType must be a string");
    h.call(this, u, t), this.type = l || "rpc", this.requestType = s, this.requestStream = n ? !0 : void 0, this.responseType = e, this.responseStream = r ? !0 : void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = o, this.parsedOptions = i;
  }
  return f.fromJSON = function(l, s) {
    return new f(l, s.type, s.requestType, s.responseType, s.requestStream, s.responseStream, s.options, s.comment, s.parsedOptions);
  }, f.prototype.toJSON = function(l) {
    var s = l ? !!l.keepComments : !1;
    return p.toObject([
      "type",
      this.type !== "rpc" && /* istanbul ignore next */
      this.type || void 0,
      "requestType",
      this.requestType,
      "requestStream",
      this.requestStream,
      "responseType",
      this.responseType,
      "responseStream",
      this.responseStream,
      "options",
      this.options,
      "comment",
      s ? this.comment : void 0,
      "parsedOptions",
      this.parsedOptions
    ]);
  }, f.prototype.resolve = function() {
    return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), h.prototype.resolve.call(this));
  }, pe;
}
var ye, je;
function Ee() {
  if (je)
    return ye;
  je = 1, ye = l;
  var h = re();
  ((l.prototype = Object.create(h.prototype)).constructor = l).className = "Service";
  var p = Ne(), f = D(), u = St;
  function l(e, n) {
    h.call(this, e, n), this.methods = {}, this._methodsArray = null;
  }
  l.fromJSON = function(n, r) {
    var t = new l(n, r.options);
    if (r.methods)
      for (var o = Object.keys(r.methods), i = 0; i < o.length; ++i)
        t.add(p.fromJSON(o[i], r.methods[o[i]]));
    return r.nested && t.addJSON(r.nested), t.comment = r.comment, t;
  }, l.prototype.toJSON = function(n) {
    var r = h.prototype.toJSON.call(this, n), t = n ? !!n.keepComments : !1;
    return f.toObject([
      "options",
      r && r.options || void 0,
      "methods",
      h.arrayToJSON(this.methodsArray, n) || /* istanbul ignore next */
      {},
      "nested",
      r && r.nested || void 0,
      "comment",
      t ? this.comment : void 0
    ]);
  }, Object.defineProperty(l.prototype, "methodsArray", {
    get: function() {
      return this._methodsArray || (this._methodsArray = f.toArray(this.methods));
    }
  });
  function s(e) {
    return e._methodsArray = null, e;
  }
  return l.prototype.get = function(n) {
    return this.methods[n] || h.prototype.get.call(this, n);
  }, l.prototype.resolveAll = function() {
    for (var n = this.methodsArray, r = 0; r < n.length; ++r)
      n[r].resolve();
    return h.prototype.resolve.call(this);
  }, l.prototype.add = function(n) {
    if (this.get(n.name))
      throw Error("duplicate name '" + n.name + "' in " + this);
    return n instanceof p ? (this.methods[n.name] = n, n.parent = this, s(this)) : h.prototype.add.call(this, n);
  }, l.prototype.remove = function(n) {
    if (n instanceof p) {
      if (this.methods[n.name] !== n)
        throw Error(n + " is not a member of " + this);
      return delete this.methods[n.name], n.parent = null, s(this);
    }
    return h.prototype.remove.call(this, n);
  }, l.prototype.create = function(n, r, t) {
    for (var o = new u.Service(n, r, t), i = 0, c; i < /* initializes */
    this.methodsArray.length; ++i) {
      var a = f.lcFirst((c = this._methodsArray[i]).resolve().name).replace(/[^$\w_]/g, "");
      o[a] = f.codegen(["r", "c"], f.isReserved(a) ? a + "_" : a)("return this.rpcCall(m,q,s,r,c)")({
        m: c,
        q: c.resolvedRequestType.ctor,
        s: c.resolvedResponseType.ctor
      });
    }
    return o;
  }, ye;
}
var Ie = U, Jt = nt();
function U(h) {
  if (h)
    for (var p = Object.keys(h), f = 0; f < p.length; ++f)
      this[p[f]] = h[p[f]];
}
U.create = function(p) {
  return this.$type.create(p);
};
U.encode = function(p, f) {
  return this.$type.encode(p, f);
};
U.encodeDelimited = function(p, f) {
  return this.$type.encodeDelimited(p, f);
};
U.decode = function(p) {
  return this.$type.decode(p);
};
U.decodeDelimited = function(p) {
  return this.$type.decodeDelimited(p);
};
U.verify = function(p) {
  return this.$type.verify(p);
};
U.fromObject = function(p) {
  return this.$type.fromObject(p);
};
U.toObject = function(p, f) {
  return this.$type.toObject(p, f);
};
U.prototype.toJSON = function() {
  return this.$type.toObject(this, Jt.toJSONOptions);
};
var me, ze;
function at() {
  if (ze)
    return me;
  ze = 1, me = l;
  var h = G(), p = Q(), f = D();
  function u(s) {
    return "missing required '" + s.name + "'";
  }
  function l(s) {
    var e = f.codegen(["r", "l"], s.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (s.fieldsArray.filter(function(c) {
      return c.map;
    }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()");
    s.group && e("if((t&7)===4)")("break"), e("switch(t>>>3){");
    for (var n = 0; n < /* initializes */
    s.fieldsArray.length; ++n) {
      var r = s._fieldsArray[n].resolve(), t = r.resolvedType instanceof h ? "int32" : r.type, o = "m" + f.safeProp(r.name);
      e("case %i: {", r.id), r.map ? (e("if(%s===util.emptyObject)", o)("%s={}", o)("var c2 = r.uint32()+r.pos"), p.defaults[r.keyType] !== void 0 ? e("k=%j", p.defaults[r.keyType]) : e("k=null"), p.defaults[t] !== void 0 ? e("value=%j", p.defaults[t]) : e("value=null"), e("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", r.keyType)("case 2:"), p.basic[t] === void 0 ? e("value=types[%i].decode(r,r.uint32())", n) : e("value=r.%s()", t), e("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), p.long[r.keyType] !== void 0 ? e('%s[typeof k==="object"?util.longToHash(k):k]=value', o) : e("%s[k]=value", o)) : r.repeated ? (e("if(!(%s&&%s.length))", o, o)("%s=[]", o), p.packed[t] !== void 0 && e("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", o, t)("}else"), p.basic[t] === void 0 ? e(r.resolvedType.group ? "%s.push(types[%i].decode(r))" : "%s.push(types[%i].decode(r,r.uint32()))", o, n) : e("%s.push(r.%s())", o, t)) : p.basic[t] === void 0 ? e(r.resolvedType.group ? "%s=types[%i].decode(r)" : "%s=types[%i].decode(r,r.uint32())", o, n) : e("%s=r.%s()", o, t), e("break")("}");
    }
    for (e("default:")("r.skipType(t&7)")("break")("}")("}"), n = 0; n < s._fieldsArray.length; ++n) {
      var i = s._fieldsArray[n];
      i.required && e("if(!m.hasOwnProperty(%j))", i.name)("throw util.ProtocolError(%j,{instance:m})", u(i));
    }
    return e("return m");
  }
  return me;
}
var ve, Ze;
function ut() {
  if (Ze)
    return ve;
  Ze = 1, ve = s;
  var h = G(), p = D();
  function f(e, n) {
    return e.name + ": " + n + (e.repeated && n !== "array" ? "[]" : e.map && n !== "object" ? "{k:" + e.keyType + "}" : "") + " expected";
  }
  function u(e, n, r, t) {
    if (n.resolvedType)
      if (n.resolvedType instanceof h) {
        e("switch(%s){", t)("default:")("return%j", f(n, "enum value"));
        for (var o = Object.keys(n.resolvedType.values), i = 0; i < o.length; ++i)
          e("case %i:", n.resolvedType.values[o[i]]);
        e("break")("}");
      } else
        e("{")("var e=types[%i].verify(%s);", r, t)("if(e)")("return%j+e", n.name + ".")("}");
    else
      switch (n.type) {
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
          e("if(!util.isInteger(%s))", t)("return%j", f(n, "integer"));
          break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
          e("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", t, t, t, t)("return%j", f(n, "integer|Long"));
          break;
        case "float":
        case "double":
          e('if(typeof %s!=="number")', t)("return%j", f(n, "number"));
          break;
        case "bool":
          e('if(typeof %s!=="boolean")', t)("return%j", f(n, "boolean"));
          break;
        case "string":
          e("if(!util.isString(%s))", t)("return%j", f(n, "string"));
          break;
        case "bytes":
          e('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', t, t, t)("return%j", f(n, "buffer"));
          break;
      }
    return e;
  }
  function l(e, n, r) {
    switch (n.keyType) {
      case "int32":
      case "uint32":
      case "sint32":
      case "fixed32":
      case "sfixed32":
        e("if(!util.key32Re.test(%s))", r)("return%j", f(n, "integer key"));
        break;
      case "int64":
      case "uint64":
      case "sint64":
      case "fixed64":
      case "sfixed64":
        e("if(!util.key64Re.test(%s))", r)("return%j", f(n, "integer|Long key"));
        break;
      case "bool":
        e("if(!util.key2Re.test(%s))", r)("return%j", f(n, "boolean key"));
        break;
    }
    return e;
  }
  function s(e) {
    var n = p.codegen(["m"], e.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"), r = e.oneofsArray, t = {};
    r.length && n("var p={}");
    for (var o = 0; o < /* initializes */
    e.fieldsArray.length; ++o) {
      var i = e._fieldsArray[o].resolve(), c = "m" + p.safeProp(i.name);
      if (i.optional && n("if(%s!=null&&m.hasOwnProperty(%j)){", c, i.name), i.map)
        n("if(!util.isObject(%s))", c)("return%j", f(i, "object"))("var k=Object.keys(%s)", c)("for(var i=0;i<k.length;++i){"), l(n, i, "k[i]"), u(n, i, o, c + "[k[i]]")("}");
      else if (i.repeated)
        n("if(!Array.isArray(%s))", c)("return%j", f(i, "array"))("for(var i=0;i<%s.length;++i){", c), u(n, i, o, c + "[i]")("}");
      else {
        if (i.partOf) {
          var a = p.safeProp(i.partOf.name);
          t[i.partOf.name] === 1 && n("if(p%s===1)", a)("return%j", i.partOf.name + ": multiple values"), t[i.partOf.name] = 1, n("p%s=1", a);
        }
        u(n, i, o, c);
      }
      i.optional && n("}");
    }
    return n("return null");
  }
  return ve;
}
var ge = {}, Ue;
function ft() {
  return Ue || (Ue = 1, function(h) {
    var p = h, f = G(), u = D();
    function l(e, n, r, t) {
      var o = !1;
      if (n.resolvedType)
        if (n.resolvedType instanceof f) {
          e("switch(d%s){", t);
          for (var i = n.resolvedType.values, c = Object.keys(i), a = 0; a < c.length; ++a)
            i[c[a]] === n.typeDefault && !o && (e("default:")('if(typeof(d%s)==="number"){m%s=d%s;break}', t, t, t), n.repeated || e("break"), o = !0), e("case%j:", c[a])("case %i:", i[c[a]])("m%s=%j", t, i[c[a]])("break");
          e("}");
        } else
          e('if(typeof d%s!=="object")', t)("throw TypeError(%j)", n.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", t, r, t);
      else {
        var y = !1;
        switch (n.type) {
          case "double":
          case "float":
            e("m%s=Number(d%s)", t, t);
            break;
          case "uint32":
          case "fixed32":
            e("m%s=d%s>>>0", t, t);
            break;
          case "int32":
          case "sint32":
          case "sfixed32":
            e("m%s=d%s|0", t, t);
            break;
          case "uint64":
            y = !0;
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            e("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", t, t, y)('else if(typeof d%s==="string")', t)("m%s=parseInt(d%s,10)", t, t)('else if(typeof d%s==="number")', t)("m%s=d%s", t, t)('else if(typeof d%s==="object")', t)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", t, t, t, y ? "true" : "");
            break;
          case "bytes":
            e('if(typeof d%s==="string")', t)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", t, t, t)("else if(d%s.length >= 0)", t)("m%s=d%s", t, t);
            break;
          case "string":
            e("m%s=String(d%s)", t, t);
            break;
          case "bool":
            e("m%s=Boolean(d%s)", t, t);
            break;
        }
      }
      return e;
    }
    p.fromObject = function(n) {
      var r = n.fieldsArray, t = u.codegen(["d"], n.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
      if (!r.length)
        return t("return new this.ctor");
      t("var m=new this.ctor");
      for (var o = 0; o < r.length; ++o) {
        var i = r[o].resolve(), c = u.safeProp(i.name);
        i.map ? (t("if(d%s){", c)('if(typeof d%s!=="object")', c)("throw TypeError(%j)", i.fullName + ": object expected")("m%s={}", c)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", c), l(
          t,
          i,
          /* not sorted */
          o,
          c + "[ks[i]]"
        )("}")("}")) : i.repeated ? (t("if(d%s){", c)("if(!Array.isArray(d%s))", c)("throw TypeError(%j)", i.fullName + ": array expected")("m%s=[]", c)("for(var i=0;i<d%s.length;++i){", c), l(
          t,
          i,
          /* not sorted */
          o,
          c + "[i]"
        )("}")("}")) : (i.resolvedType instanceof f || t("if(d%s!=null){", c), l(
          t,
          i,
          /* not sorted */
          o,
          c
        ), i.resolvedType instanceof f || t("}"));
      }
      return t("return m");
    };
    function s(e, n, r, t) {
      if (n.resolvedType)
        n.resolvedType instanceof f ? e("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", t, r, t, t, r, t, t) : e("d%s=types[%i].toObject(m%s,o)", t, r, t);
      else {
        var o = !1;
        switch (n.type) {
          case "double":
          case "float":
            e("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", t, t, t, t);
            break;
          case "uint64":
            o = !0;
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            e('if(typeof m%s==="number")', t)("d%s=o.longs===String?String(m%s):m%s", t, t, t)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", t, t, t, t, o ? "true" : "", t);
            break;
          case "bytes":
            e("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", t, t, t, t, t);
            break;
          default:
            e("d%s=m%s", t, t);
            break;
        }
      }
      return e;
    }
    p.toObject = function(n) {
      var r = n.fieldsArray.slice().sort(u.compareFieldsById);
      if (!r.length)
        return u.codegen()("return {}");
      for (var t = u.codegen(["m", "o"], n.name + "$toObject")("if(!o)")("o={}")("var d={}"), o = [], i = [], c = [], a = 0; a < r.length; ++a)
        r[a].partOf || (r[a].resolve().repeated ? o : r[a].map ? i : c).push(r[a]);
      if (o.length) {
        for (t("if(o.arrays||o.defaults){"), a = 0; a < o.length; ++a)
          t("d%s=[]", u.safeProp(o[a].name));
        t("}");
      }
      if (i.length) {
        for (t("if(o.objects||o.defaults){"), a = 0; a < i.length; ++a)
          t("d%s={}", u.safeProp(i[a].name));
        t("}");
      }
      if (c.length) {
        for (t("if(o.defaults){"), a = 0; a < c.length; ++a) {
          var y = c[a], m = u.safeProp(y.name);
          if (y.resolvedType instanceof f)
            t("d%s=o.enums===String?%j:%j", m, y.resolvedType.valuesById[y.typeDefault], y.typeDefault);
          else if (y.long)
            t("if(util.Long){")("var n=new util.Long(%i,%i,%j)", y.typeDefault.low, y.typeDefault.high, y.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", m)("}else")("d%s=o.longs===String?%j:%i", m, y.typeDefault.toString(), y.typeDefault.toNumber());
          else if (y.bytes) {
            var x = "[" + Array.prototype.slice.call(y.typeDefault).join(",") + "]";
            t("if(o.bytes===String)d%s=%j", m, String.fromCharCode.apply(String, y.typeDefault))("else{")("d%s=%s", m, x)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", m, m)("}");
          } else
            t("d%s=%j", m, y.typeDefault);
        }
        t("}");
      }
      var A = !1;
      for (a = 0; a < r.length; ++a) {
        var y = r[a], d = n._fieldsArray.indexOf(y), m = u.safeProp(y.name);
        y.map ? (A || (A = !0, t("var ks2")), t("if(m%s&&(ks2=Object.keys(m%s)).length){", m, m)("d%s={}", m)("for(var j=0;j<ks2.length;++j){"), s(
          t,
          y,
          /* sorted */
          d,
          m + "[ks2[j]]"
        )("}")) : y.repeated ? (t("if(m%s&&m%s.length){", m, m)("d%s=[]", m)("for(var j=0;j<m%s.length;++j){", m), s(
          t,
          y,
          /* sorted */
          d,
          m + "[j]"
        )("}")) : (t("if(m%s!=null&&m.hasOwnProperty(%j)){", m, y.name), s(
          t,
          y,
          /* sorted */
          d,
          m
        ), y.partOf && t("if(o.oneofs)")("d%s=%j", u.safeProp(y.partOf.name), y.name)), t("}");
      }
      return t("return d");
    };
  }(ge)), ge;
}
var Fe = {};
(function(h) {
  var p = h, f = Ie;
  p[".google.protobuf.Any"] = {
    fromObject: function(u) {
      if (u && u["@type"]) {
        var l = u["@type"].substring(u["@type"].lastIndexOf("/") + 1), s = this.lookup(l);
        if (s) {
          var e = u["@type"].charAt(0) === "." ? u["@type"].slice(1) : u["@type"];
          return e.indexOf("/") === -1 && (e = "/" + e), this.create({
            type_url: e,
            value: s.encode(s.fromObject(u)).finish()
          });
        }
      }
      return this.fromObject(u);
    },
    toObject: function(u, l) {
      var s = "type.googleapis.com/", e = "", n = "";
      if (l && l.json && u.type_url && u.value) {
        n = u.type_url.substring(u.type_url.lastIndexOf("/") + 1), e = u.type_url.substring(0, u.type_url.lastIndexOf("/") + 1);
        var r = this.lookup(n);
        r && (u = r.decode(u.value));
      }
      if (!(u instanceof this.ctor) && u instanceof f) {
        var t = u.$type.toObject(u, l), o = u.$type.fullName[0] === "." ? u.$type.fullName.slice(1) : u.$type.fullName;
        return e === "" && (e = s), n = e + o, t["@type"] = n, t;
      }
      return this.toObject(u, l);
    }
  };
})(Fe);
var Oe, Ge;
function qe() {
  if (Ge)
    return Oe;
  Ge = 1, Oe = m;
  var h = re();
  ((m.prototype = Object.create(h.prototype)).constructor = m).className = "Type";
  var p = G(), f = te(), u = X(), l = Te(), s = Ee(), e = Ie, n = xt, r = Rt, t = D(), o = lt(), i = at(), c = ut(), a = ft(), y = Fe;
  function m(A, d) {
    h.call(this, A, d), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
  }
  Object.defineProperties(m.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */
    fieldsById: {
      get: function() {
        if (this._fieldsById)
          return this._fieldsById;
        this._fieldsById = {};
        for (var A = Object.keys(this.fields), d = 0; d < A.length; ++d) {
          var O = this.fields[A[d]], b = O.id;
          if (this._fieldsById[b])
            throw Error("duplicate id " + b + " in " + this);
          this._fieldsById[b] = O;
        }
        return this._fieldsById;
      }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */
    fieldsArray: {
      get: function() {
        return this._fieldsArray || (this._fieldsArray = t.toArray(this.fields));
      }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */
    oneofsArray: {
      get: function() {
        return this._oneofsArray || (this._oneofsArray = t.toArray(this.oneofs));
      }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */
    ctor: {
      get: function() {
        return this._ctor || (this.ctor = m.generateConstructor(this)());
      },
      set: function(A) {
        var d = A.prototype;
        d instanceof e || ((A.prototype = new e()).constructor = A, t.merge(A.prototype, d)), A.$type = A.prototype.$type = this, t.merge(A, e, !0), this._ctor = A;
        for (var O = 0; O < /* initializes */
        this.fieldsArray.length; ++O)
          this._fieldsArray[O].resolve();
        var b = {};
        for (O = 0; O < /* initializes */
        this.oneofsArray.length; ++O)
          b[this._oneofsArray[O].resolve().name] = {
            get: t.oneOfGetter(this._oneofsArray[O].oneof),
            set: t.oneOfSetter(this._oneofsArray[O].oneof)
          };
        O && Object.defineProperties(A.prototype, b);
      }
    }
  }), m.generateConstructor = function(d) {
    for (var O = t.codegen(["p"], d.name), b = 0, R; b < d.fieldsArray.length; ++b)
      (R = d._fieldsArray[b]).map ? O("this%s={}", t.safeProp(R.name)) : R.repeated && O("this%s=[]", t.safeProp(R.name));
    return O("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
  };
  function x(A) {
    return A._fieldsById = A._fieldsArray = A._oneofsArray = null, delete A.encode, delete A.decode, delete A.verify, A;
  }
  return m.fromJSON = function(d, O) {
    var b = new m(d, O.options);
    b.extensions = O.extensions, b.reserved = O.reserved;
    for (var R = Object.keys(O.fields), _ = 0; _ < R.length; ++_)
      b.add(
        (typeof O.fields[R[_]].keyType < "u" ? l.fromJSON : u.fromJSON)(R[_], O.fields[R[_]])
      );
    if (O.oneofs)
      for (R = Object.keys(O.oneofs), _ = 0; _ < R.length; ++_)
        b.add(f.fromJSON(R[_], O.oneofs[R[_]]));
    if (O.nested)
      for (R = Object.keys(O.nested), _ = 0; _ < R.length; ++_) {
        var I = O.nested[R[_]];
        b.add(
          // most to least likely
          (I.id !== void 0 ? u.fromJSON : I.fields !== void 0 ? m.fromJSON : I.values !== void 0 ? p.fromJSON : I.methods !== void 0 ? s.fromJSON : h.fromJSON)(R[_], I)
        );
      }
    return O.extensions && O.extensions.length && (b.extensions = O.extensions), O.reserved && O.reserved.length && (b.reserved = O.reserved), O.group && (b.group = !0), O.comment && (b.comment = O.comment), b;
  }, m.prototype.toJSON = function(d) {
    var O = h.prototype.toJSON.call(this, d), b = d ? !!d.keepComments : !1;
    return t.toObject([
      "options",
      O && O.options || void 0,
      "oneofs",
      h.arrayToJSON(this.oneofsArray, d),
      "fields",
      h.arrayToJSON(this.fieldsArray.filter(function(R) {
        return !R.declaringField;
      }), d) || {},
      "extensions",
      this.extensions && this.extensions.length ? this.extensions : void 0,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "group",
      this.group || void 0,
      "nested",
      O && O.nested || void 0,
      "comment",
      b ? this.comment : void 0
    ]);
  }, m.prototype.resolveAll = function() {
    for (var d = this.fieldsArray, O = 0; O < d.length; )
      d[O++].resolve();
    var b = this.oneofsArray;
    for (O = 0; O < b.length; )
      b[O++].resolve();
    return h.prototype.resolveAll.call(this);
  }, m.prototype.get = function(d) {
    return this.fields[d] || this.oneofs && this.oneofs[d] || this.nested && this.nested[d] || null;
  }, m.prototype.add = function(d) {
    if (this.get(d.name))
      throw Error("duplicate name '" + d.name + "' in " + this);
    if (d instanceof u && d.extend === void 0) {
      if (this._fieldsById ? (
        /* istanbul ignore next */
        this._fieldsById[d.id]
      ) : this.fieldsById[d.id])
        throw Error("duplicate id " + d.id + " in " + this);
      if (this.isReservedId(d.id))
        throw Error("id " + d.id + " is reserved in " + this);
      if (this.isReservedName(d.name))
        throw Error("name '" + d.name + "' is reserved in " + this);
      return d.parent && d.parent.remove(d), this.fields[d.name] = d, d.message = this, d.onAdd(this), x(this);
    }
    return d instanceof f ? (this.oneofs || (this.oneofs = {}), this.oneofs[d.name] = d, d.onAdd(this), x(this)) : h.prototype.add.call(this, d);
  }, m.prototype.remove = function(d) {
    if (d instanceof u && d.extend === void 0) {
      if (!this.fields || this.fields[d.name] !== d)
        throw Error(d + " is not a member of " + this);
      return delete this.fields[d.name], d.parent = null, d.onRemove(this), x(this);
    }
    if (d instanceof f) {
      if (!this.oneofs || this.oneofs[d.name] !== d)
        throw Error(d + " is not a member of " + this);
      return delete this.oneofs[d.name], d.parent = null, d.onRemove(this), x(this);
    }
    return h.prototype.remove.call(this, d);
  }, m.prototype.isReservedId = function(d) {
    return h.isReservedId(this.reserved, d);
  }, m.prototype.isReservedName = function(d) {
    return h.isReservedName(this.reserved, d);
  }, m.prototype.create = function(d) {
    return new this.ctor(d);
  }, m.prototype.setup = function() {
    for (var d = this.fullName, O = [], b = 0; b < /* initializes */
    this.fieldsArray.length; ++b)
      O.push(this._fieldsArray[b].resolve().resolvedType);
    this.encode = o(this)({
      Writer: r,
      types: O,
      util: t
    }), this.decode = i(this)({
      Reader: n,
      types: O,
      util: t
    }), this.verify = c(this)({
      types: O,
      util: t
    }), this.fromObject = a.fromObject(this)({
      types: O,
      util: t
    }), this.toObject = a.toObject(this)({
      types: O,
      util: t
    });
    var R = y[d];
    if (R) {
      var _ = Object.create(this);
      _.fromObject = this.fromObject, this.fromObject = R.fromObject.bind(_), _.toObject = this.toObject, this.toObject = R.toObject.bind(_);
    }
    return this;
  }, m.prototype.encode = function(d, O) {
    return this.setup().encode(d, O);
  }, m.prototype.encodeDelimited = function(d, O) {
    return this.encode(d, O && O.len ? O.fork() : O).ldelim();
  }, m.prototype.decode = function(d, O) {
    return this.setup().decode(d, O);
  }, m.prototype.decodeDelimited = function(d) {
    return d instanceof n || (d = n.create(d)), this.decode(d, d.uint32());
  }, m.prototype.verify = function(d) {
    return this.setup().verify(d);
  }, m.prototype.fromObject = function(d) {
    return this.setup().fromObject(d);
  }, m.prototype.toObject = function(d, O) {
    return this.setup().toObject(d, O);
  }, m.d = function(d) {
    return function(b) {
      t.decorateType(b, d);
    };
  }, Oe;
}
var we, We;
function Je() {
  if (We)
    return we;
  We = 1, we = r;
  var h = re();
  ((r.prototype = Object.create(h.prototype)).constructor = r).className = "Root";
  var p = X(), f = G(), u = te(), l = D(), s, e, n;
  function r(c) {
    h.call(this, "", c), this.deferred = [], this.files = [];
  }
  r.fromJSON = function(a, y) {
    return y || (y = new r()), a.options && y.setOptions(a.options), y.addJSON(a.nested);
  }, r.prototype.resolvePath = l.path.resolve, r.prototype.fetch = l.fetch;
  function t() {
  }
  r.prototype.load = function c(a, y, m) {
    typeof y == "function" && (m = y, y = void 0);
    var x = this;
    if (!m)
      return l.asPromise(c, x, a, y);
    var A = m === t;
    function d(N, q) {
      if (m) {
        if (A)
          throw N;
        var J = m;
        m = null, J(N, q);
      }
    }
    function O(N) {
      var q = N.lastIndexOf("google/protobuf/");
      if (q > -1) {
        var J = N.substring(q);
        if (J in n)
          return J;
      }
      return null;
    }
    function b(N, q) {
      try {
        if (l.isString(q) && q.charAt(0) === "{" && (q = JSON.parse(q)), !l.isString(q))
          x.setOptions(q.options).addJSON(q.nested);
        else {
          e.filename = N;
          var J = e(q, x, y), F, P = 0;
          if (J.imports)
            for (; P < J.imports.length; ++P)
              (F = O(J.imports[P]) || x.resolvePath(N, J.imports[P])) && R(F);
          if (J.weakImports)
            for (P = 0; P < J.weakImports.length; ++P)
              (F = O(J.weakImports[P]) || x.resolvePath(N, J.weakImports[P])) && R(F, !0);
        }
      } catch (V) {
        d(V);
      }
      !A && !_ && d(null, x);
    }
    function R(N, q) {
      if (N = O(N) || N, !(x.files.indexOf(N) > -1)) {
        if (x.files.push(N), N in n) {
          A ? b(N, n[N]) : (++_, setTimeout(function() {
            --_, b(N, n[N]);
          }));
          return;
        }
        if (A) {
          var J;
          try {
            J = l.fs.readFileSync(N).toString("utf8");
          } catch (F) {
            q || d(F);
            return;
          }
          b(N, J);
        } else
          ++_, x.fetch(N, function(F, P) {
            if (--_, !!m) {
              if (F) {
                q ? _ || d(null, x) : d(F);
                return;
              }
              b(N, P);
            }
          });
      }
    }
    var _ = 0;
    l.isString(a) && (a = [a]);
    for (var I = 0, C; I < a.length; ++I)
      (C = x.resolvePath("", a[I])) && R(C);
    if (A)
      return x;
    _ || d(null, x);
  }, r.prototype.loadSync = function(a, y) {
    if (!l.isNode)
      throw Error("not supported");
    return this.load(a, y, t);
  }, r.prototype.resolveAll = function() {
    if (this.deferred.length)
      throw Error("unresolvable extensions: " + this.deferred.map(function(a) {
        return "'extend " + a.extend + "' in " + a.parent.fullName;
      }).join(", "));
    return h.prototype.resolveAll.call(this);
  };
  var o = /^[A-Z]/;
  function i(c, a) {
    var y = a.parent.lookup(a.extend);
    if (y) {
      var m = new p(a.fullName, a.id, a.type, a.rule, void 0, a.options);
      return y.get(m.name) || (m.declaringField = a, a.extensionField = m, y.add(m)), !0;
    }
    return !1;
  }
  return r.prototype._handleAdd = function(a) {
    if (a instanceof p)
      /* an extension field (implies not part of a oneof) */
      a.extend !== void 0 && /* not already handled */
      !a.extensionField && (i(this, a) || this.deferred.push(a));
    else if (a instanceof f)
      o.test(a.name) && (a.parent[a.name] = a.values);
    else if (!(a instanceof u)) {
      if (a instanceof s)
        for (var y = 0; y < this.deferred.length; )
          i(this, this.deferred[y]) ? this.deferred.splice(y, 1) : ++y;
      for (var m = 0; m < /* initializes */
      a.nestedArray.length; ++m)
        this._handleAdd(a._nestedArray[m]);
      o.test(a.name) && (a.parent[a.name] = a);
    }
  }, r.prototype._handleRemove = function(a) {
    if (a instanceof p) {
      if (
        /* an extension field */
        a.extend !== void 0
      )
        if (
          /* already handled */
          a.extensionField
        )
          a.extensionField.parent.remove(a.extensionField), a.extensionField = null;
        else {
          var y = this.deferred.indexOf(a);
          y > -1 && this.deferred.splice(y, 1);
        }
    } else if (a instanceof f)
      o.test(a.name) && delete a.parent[a.name];
    else if (a instanceof h) {
      for (var m = 0; m < /* initializes */
      a.nestedArray.length; ++m)
        this._handleRemove(a._nestedArray[m]);
      o.test(a.name) && delete a.parent[a.name];
    }
  }, r._configure = function(c, a, y) {
    s = c, e = a, n = y;
  }, we;
}
var He;
function D() {
  if (He)
    return ae.exports;
  He = 1;
  var h = ae.exports = nt(), p = Tt, f, u;
  h.codegen = Et, h.fetch = It, h.path = ot, h.fs = h.inquire("fs"), h.toArray = function(t) {
    if (t) {
      for (var o = Object.keys(t), i = new Array(o.length), c = 0; c < o.length; )
        i[c] = t[o[c++]];
      return i;
    }
    return [];
  }, h.toObject = function(t) {
    for (var o = {}, i = 0; i < t.length; ) {
      var c = t[i++], a = t[i++];
      a !== void 0 && (o[c] = a);
    }
    return o;
  };
  var l = /\\/g, s = /"/g;
  h.isReserved = function(t) {
    return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(t);
  }, h.safeProp = function(t) {
    return !/^[$\w_]+$/.test(t) || h.isReserved(t) ? '["' + t.replace(l, "\\\\").replace(s, '\\"') + '"]' : "." + t;
  }, h.ucFirst = function(t) {
    return t.charAt(0).toUpperCase() + t.substring(1);
  };
  var e = /_([a-z])/g;
  h.camelCase = function(t) {
    return t.substring(0, 1) + t.substring(1).replace(e, function(o, i) {
      return i.toUpperCase();
    });
  }, h.compareFieldsById = function(t, o) {
    return t.id - o.id;
  }, h.decorateType = function(t, o) {
    if (t.$type)
      return o && t.$type.name !== o && (h.decorateRoot.remove(t.$type), t.$type.name = o, h.decorateRoot.add(t.$type)), t.$type;
    f || (f = qe());
    var i = new f(o || t.name);
    return h.decorateRoot.add(i), i.ctor = t, Object.defineProperty(t, "$type", { value: i, enumerable: !1 }), Object.defineProperty(t.prototype, "$type", { value: i, enumerable: !1 }), i;
  };
  var n = 0;
  return h.decorateEnum = function(t) {
    if (t.$type)
      return t.$type;
    u || (u = G());
    var o = new u("Enum" + n++, t);
    return h.decorateRoot.add(o), Object.defineProperty(t, "$type", { value: o, enumerable: !1 }), o;
  }, h.setProperty = function(t, o, i) {
    function c(a, y, m) {
      var x = y.shift();
      if (x === "__proto__" || x === "prototype")
        return a;
      if (y.length > 0)
        a[x] = c(a[x] || {}, y, m);
      else {
        var A = a[x];
        A && (m = [].concat(A).concat(m)), a[x] = m;
      }
      return a;
    }
    if (typeof t != "object")
      throw TypeError("dst must be an object");
    if (!o)
      throw TypeError("path must be specified");
    return o = o.split("."), c(t, o, i);
  }, Object.defineProperty(h, "decorateRoot", {
    get: function() {
      return p.decorated || (p.decorated = new (Je())());
    }
  }), ae.exports;
}
var be, Ke;
function Y() {
  if (Ke)
    return be;
  Ke = 1, be = f, f.className = "ReflectionObject";
  var h = D(), p;
  function f(u, l) {
    if (!h.isString(u))
      throw TypeError("name must be a string");
    if (l && !h.isObject(l))
      throw TypeError("options must be an object");
    this.options = l, this.parsedOptions = null, this.name = u, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
  }
  return Object.defineProperties(f.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */
    root: {
      get: function() {
        for (var u = this; u.parent !== null; )
          u = u.parent;
        return u;
      }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */
    fullName: {
      get: function() {
        for (var u = [this.name], l = this.parent; l; )
          u.unshift(l.name), l = l.parent;
        return u.join(".");
      }
    }
  }), f.prototype.toJSON = /* istanbul ignore next */
  function() {
    throw Error();
  }, f.prototype.onAdd = function(l) {
    this.parent && this.parent !== l && this.parent.remove(this), this.parent = l, this.resolved = !1;
    var s = l.root;
    s instanceof p && s._handleAdd(this);
  }, f.prototype.onRemove = function(l) {
    var s = l.root;
    s instanceof p && s._handleRemove(this), this.parent = null, this.resolved = !1;
  }, f.prototype.resolve = function() {
    return this.resolved ? this : (this.root instanceof p && (this.resolved = !0), this);
  }, f.prototype.getOption = function(l) {
    if (this.options)
      return this.options[l];
  }, f.prototype.setOption = function(l, s, e) {
    return (!e || !this.options || this.options[l] === void 0) && ((this.options || (this.options = {}))[l] = s), this;
  }, f.prototype.setParsedOption = function(l, s, e) {
    this.parsedOptions || (this.parsedOptions = []);
    var n = this.parsedOptions;
    if (e) {
      var r = n.find(function(i) {
        return Object.prototype.hasOwnProperty.call(i, l);
      });
      if (r) {
        var t = r[l];
        h.setProperty(t, e, s);
      } else
        r = {}, r[l] = h.setProperty({}, e, s), n.push(r);
    } else {
      var o = {};
      o[l] = s, n.push(o);
    }
    return this;
  }, f.prototype.setOptions = function(l, s) {
    if (l)
      for (var e = Object.keys(l), n = 0; n < e.length; ++n)
        this.setOption(e[n], l[e[n]], s);
    return this;
  }, f.prototype.toString = function() {
    var l = this.constructor.className, s = this.fullName;
    return s.length ? l + " " + s : l;
  }, f._configure = function(u) {
    p = u;
  }, be;
}
var Ae, Xe;
function G() {
  if (Xe)
    return Ae;
  Xe = 1, Ae = u;
  var h = Y();
  ((u.prototype = Object.create(h.prototype)).constructor = u).className = "Enum";
  var p = re(), f = D();
  function u(l, s, e, n, r, t) {
    if (h.call(this, l, e), s && typeof s != "object")
      throw TypeError("values must be an object");
    if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = n, this.comments = r || {}, this.valuesOptions = t, this.reserved = void 0, s)
      for (var o = Object.keys(s), i = 0; i < o.length; ++i)
        typeof s[o[i]] == "number" && (this.valuesById[this.values[o[i]] = s[o[i]]] = o[i]);
  }
  return u.fromJSON = function(s, e) {
    var n = new u(s, e.values, e.options, e.comment, e.comments);
    return n.reserved = e.reserved, n;
  }, u.prototype.toJSON = function(s) {
    var e = s ? !!s.keepComments : !1;
    return f.toObject([
      "options",
      this.options,
      "valuesOptions",
      this.valuesOptions,
      "values",
      this.values,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "comment",
      e ? this.comment : void 0,
      "comments",
      e ? this.comments : void 0
    ]);
  }, u.prototype.add = function(s, e, n, r) {
    if (!f.isString(s))
      throw TypeError("name must be a string");
    if (!f.isInteger(e))
      throw TypeError("id must be an integer");
    if (this.values[s] !== void 0)
      throw Error("duplicate name '" + s + "' in " + this);
    if (this.isReservedId(e))
      throw Error("id " + e + " is reserved in " + this);
    if (this.isReservedName(s))
      throw Error("name '" + s + "' is reserved in " + this);
    if (this.valuesById[e] !== void 0) {
      if (!(this.options && this.options.allow_alias))
        throw Error("duplicate id " + e + " in " + this);
      this.values[s] = e;
    } else
      this.valuesById[this.values[s] = e] = s;
    return r && (this.valuesOptions === void 0 && (this.valuesOptions = {}), this.valuesOptions[s] = r || null), this.comments[s] = n || null, this;
  }, u.prototype.remove = function(s) {
    if (!f.isString(s))
      throw TypeError("name must be a string");
    var e = this.values[s];
    if (e == null)
      throw Error("name '" + s + "' does not exist in " + this);
    return delete this.valuesById[e], delete this.values[s], delete this.comments[s], this.valuesOptions && delete this.valuesOptions[s], this;
  }, u.prototype.isReservedId = function(s) {
    return p.isReservedId(this.reserved, s);
  }, u.prototype.isReservedName = function(s) {
    return p.isReservedName(this.reserved, s);
  }, Ae;
}
var ke, Qe;
function lt() {
  if (Qe)
    return ke;
  Qe = 1, ke = l;
  var h = G(), p = Q(), f = D();
  function u(s, e, n, r) {
    return e.resolvedType.group ? s("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", n, r, (e.id << 3 | 3) >>> 0, (e.id << 3 | 4) >>> 0) : s("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", n, r, (e.id << 3 | 2) >>> 0);
  }
  function l(s) {
    for (var e = f.codegen(["m", "w"], s.name + "$encode")("if(!w)")("w=Writer.create()"), n, r, t = (
      /* initializes */
      s.fieldsArray.slice().sort(f.compareFieldsById)
    ), n = 0; n < t.length; ++n) {
      var o = t[n].resolve(), i = s._fieldsArray.indexOf(o), c = o.resolvedType instanceof h ? "int32" : o.type, a = p.basic[c];
      r = "m" + f.safeProp(o.name), o.map ? (e("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", r, o.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", r)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (o.id << 3 | 2) >>> 0, 8 | p.mapKey[o.keyType], o.keyType), a === void 0 ? e("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", i, r) : e(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | a, c, r), e("}")("}")) : o.repeated ? (e("if(%s!=null&&%s.length){", r, r), o.packed && p.packed[c] !== void 0 ? e("w.uint32(%i).fork()", (o.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", r)("w.%s(%s[i])", c, r)("w.ldelim()") : (e("for(var i=0;i<%s.length;++i)", r), a === void 0 ? u(e, o, i, r + "[i]") : e("w.uint32(%i).%s(%s[i])", (o.id << 3 | a) >>> 0, c, r)), e("}")) : (o.optional && e("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", r, o.name), a === void 0 ? u(e, o, i, r) : e("w.uint32(%i).%s(%s)", (o.id << 3 | a) >>> 0, c, r));
    }
    return e("return w");
  }
  return ke;
}
var E = st.exports = Nt;
E.build = "light";
function $t(h, p, f) {
  return typeof p == "function" ? (f = p, p = new E.Root()) : p || (p = new E.Root()), p.load(h, f);
}
E.load = $t;
function Dt(h, p) {
  return p || (p = new E.Root()), p.loadSync(h);
}
E.loadSync = Dt;
E.encoder = lt();
E.decoder = at();
E.verifier = ut();
E.converter = ft();
E.ReflectionObject = Y();
E.Namespace = re();
E.Root = Je();
E.Enum = G();
E.Type = qe();
E.Field = X();
E.OneOf = te();
E.MapField = Te();
E.Service = Ee();
E.Method = Ne();
E.Message = Ie;
E.wrappers = Fe;
E.types = Q();
E.util = D();
E.ReflectionObject._configure(E.Root);
E.Namespace._configure(E.Type, E.Service, E.Enum);
E.Root._configure(E.Type);
E.Field._configure(E.Type);
var Ct = st.exports, dt = ht, _e = /[\s{}=;:[\],'"()<>]/g, Bt = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, Pt = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g, Vt = /^ *[*/]+ */, Mt = /^\s*\*?\/*/, Lt = /\n/g, jt = /\s/, zt = /\\(.?)/g, Zt = {
  0: "\0",
  r: "\r",
  n: `
`,
  t: "	"
};
function ct(h) {
  return h.replace(zt, function(p, f) {
    switch (f) {
      case "\\":
      case "":
        return f;
      default:
        return Zt[f] || "";
    }
  });
}
ht.unescape = ct;
function ht(h, p) {
  h = h.toString();
  var f = 0, u = h.length, l = 1, s = 0, e = {}, n = [], r = null;
  function t(b) {
    return Error("illegal " + b + " (line " + l + ")");
  }
  function o() {
    var b = r === "'" ? Pt : Bt;
    b.lastIndex = f - 1;
    var R = b.exec(h);
    if (!R)
      throw t("string");
    return f = b.lastIndex, x(r), r = null, ct(R[1]);
  }
  function i(b) {
    return h.charAt(b);
  }
  function c(b, R, _) {
    var I = {
      type: h.charAt(b++),
      lineEmpty: !1,
      leading: _
    }, C;
    p ? C = 2 : C = 3;
    var N = b - C, q;
    do
      if (--N < 0 || (q = h.charAt(N)) === `
`) {
        I.lineEmpty = !0;
        break;
      }
    while (q === " " || q === "	");
    for (var J = h.substring(b, R).split(Lt), F = 0; F < J.length; ++F)
      J[F] = J[F].replace(p ? Mt : Vt, "").trim();
    I.text = J.join(`
`).trim(), e[l] = I, s = l;
  }
  function a(b) {
    var R = y(b), _ = h.substring(b, R), I = /^\s*\/\//.test(_);
    return I;
  }
  function y(b) {
    for (var R = b; R < u && i(R) !== `
`; )
      R++;
    return R;
  }
  function m() {
    if (n.length > 0)
      return n.shift();
    if (r)
      return o();
    var b, R, _, I, C, N = f === 0;
    do {
      if (f === u)
        return null;
      for (b = !1; jt.test(_ = i(f)); )
        if (_ === `
` && (N = !0, ++l), ++f === u)
          return null;
      if (i(f) === "/") {
        if (++f === u)
          throw t("comment");
        if (i(f) === "/")
          if (p) {
            if (I = f, C = !1, a(f - 1)) {
              C = !0;
              do
                if (f = y(f), f === u || (f++, !N))
                  break;
              while (a(f));
            } else
              f = Math.min(u, y(f) + 1);
            C && (c(I, f, N), N = !0), l++, b = !0;
          } else {
            for (C = i(I = f + 1) === "/"; i(++f) !== `
`; )
              if (f === u)
                return null;
            ++f, C && (c(I, f - 1, N), N = !0), ++l, b = !0;
          }
        else if ((_ = i(f)) === "*") {
          I = f + 1, C = p || i(I) === "*";
          do {
            if (_ === `
` && ++l, ++f === u)
              throw t("comment");
            R = _, _ = i(f);
          } while (R !== "*" || _ !== "/");
          ++f, C && (c(I, f - 2, N), N = !0), b = !0;
        } else
          return "/";
      }
    } while (b);
    var q = f;
    _e.lastIndex = 0;
    var J = _e.test(i(q++));
    if (!J)
      for (; q < u && !_e.test(i(q)); )
        ++q;
    var F = h.substring(f, f = q);
    return (F === '"' || F === "'") && (r = F), F;
  }
  function x(b) {
    n.push(b);
  }
  function A() {
    if (!n.length) {
      var b = m();
      if (b === null)
        return null;
      x(b);
    }
    return n[0];
  }
  function d(b, R) {
    var _ = A(), I = _ === b;
    if (I)
      return m(), !0;
    if (!R)
      throw t("token '" + _ + "', '" + b + "' expected");
    return !1;
  }
  function O(b) {
    var R = null, _;
    return b === void 0 ? (_ = e[l - 1], delete e[l - 1], _ && (p || _.type === "*" || _.lineEmpty) && (R = _.leading ? _.text : null)) : (s < b && A(), _ = e[b], delete e[b], _ && !_.lineEmpty && (p || _.type === "/") && (R = _.leading ? null : _.text)), R;
  }
  return Object.defineProperty({
    next: m,
    peek: A,
    push: x,
    skip: d,
    cmnt: O
  }, "line", {
    get: function() {
      return l;
    }
  });
}
var Ut = W;
W.filename = null;
W.defaults = { keepCase: !1 };
var Gt = dt, Ye = Je(), et = qe(), tt = X(), Wt = Te(), rt = te(), Ht = G(), Kt = Ee(), Xt = Ne(), Se = Q(), Re = D(), Qt = /^[1-9][0-9]*$/, Yt = /^-?[1-9][0-9]*$/, er = /^0[x][0-9a-fA-F]+$/, tr = /^-?0[x][0-9a-fA-F]+$/, rr = /^0[0-7]+$/, nr = /^-?0[0-7]+$/, ir = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, z = /^[a-zA-Z_][a-zA-Z_0-9]*$/, Z = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/, sr = /^(?:\.[a-zA-Z_][a-zA-Z_0-9]*)+$/;
function W(h, p, f) {
  p instanceof Ye || (f = p, p = new Ye()), f || (f = W.defaults);
  var u = f.preferTrailingComment || !1, l = Gt(h, f.alternateCommentMode || !1), s = l.next, e = l.push, n = l.peek, r = l.skip, t = l.cmnt, o = !0, i, c, a, y, m = !1, x = p, A = f.keepCase ? function(g) {
    return g;
  } : Re.camelCase;
  function d(g, v, w) {
    var S = W.filename;
    return w || (W.filename = null), Error("illegal " + (v || "token") + " '" + g + "' (" + (S ? S + ", " : "") + "line " + l.line + ")");
  }
  function O() {
    var g = [], v;
    do {
      if ((v = s()) !== '"' && v !== "'")
        throw d(v);
      g.push(s()), r(v), v = n();
    } while (v === '"' || v === "'");
    return g.join("");
  }
  function b(g) {
    var v = s();
    switch (v) {
      case "'":
      case '"':
        return e(v), O();
      case "true":
      case "TRUE":
        return !0;
      case "false":
      case "FALSE":
        return !1;
    }
    try {
      return _(
        v,
        /* insideTryCatch */
        !0
      );
    } catch {
      if (Z.test(v))
        return v;
      throw d(v, "value");
    }
  }
  function R(g, v) {
    var w, S;
    do
      v && ((w = n()) === '"' || w === "'") ? g.push(O()) : g.push([S = I(s()), r("to", !0) ? I(s()) : S]);
    while (r(",", !0));
    var k = { options: void 0 };
    k.setOption = function(T, $) {
      this.options === void 0 && (this.options = {}), this.options[T] = $;
    }, F(
      k,
      function($) {
        if ($ === "option")
          L(k, $), r(";");
        else
          throw d($);
      },
      function() {
        ne(k);
      }
    );
  }
  function _(g, v) {
    var w = 1;
    switch (g.charAt(0) === "-" && (w = -1, g = g.substring(1)), g) {
      case "inf":
      case "INF":
      case "Inf":
        return w * (1 / 0);
      case "nan":
      case "NAN":
      case "Nan":
      case "NaN":
        return NaN;
      case "0":
        return 0;
    }
    if (Qt.test(g))
      return w * parseInt(g, 10);
    if (er.test(g))
      return w * parseInt(g, 16);
    if (rr.test(g))
      return w * parseInt(g, 8);
    if (ir.test(g))
      return w * parseFloat(g);
    throw d(g, "number", v);
  }
  function I(g, v) {
    switch (g) {
      case "max":
      case "MAX":
      case "Max":
        return 536870911;
      case "0":
        return 0;
    }
    if (!v && g.charAt(0) === "-")
      throw d(g, "id");
    if (Yt.test(g))
      return parseInt(g, 10);
    if (tr.test(g))
      return parseInt(g, 16);
    if (nr.test(g))
      return parseInt(g, 8);
    throw d(g, "id");
  }
  function C() {
    if (i !== void 0)
      throw d("package");
    if (i = s(), !Z.test(i))
      throw d(i, "name");
    x = x.define(i), r(";");
  }
  function N() {
    var g = n(), v;
    switch (g) {
      case "weak":
        v = a || (a = []), s();
        break;
      case "public":
        s();
      default:
        v = c || (c = []);
        break;
    }
    g = O(), r(";"), v.push(g);
  }
  function q() {
    if (r("="), y = O(), m = y === "proto3", !m && y !== "proto2")
      throw d(y, "syntax");
    r(";");
  }
  function J(g, v) {
    switch (v) {
      case "option":
        return L(g, v), r(";"), !0;
      case "message":
        return P(g, v), !0;
      case "enum":
        return $e(g, v), !0;
      case "service":
        return wt(g, v), !0;
      case "extend":
        return At(g, v), !0;
    }
    return !1;
  }
  function F(g, v, w) {
    var S = l.line;
    if (g && (typeof g.comment != "string" && (g.comment = t()), g.filename = W.filename), r("{", !0)) {
      for (var k; (k = s()) !== "}"; )
        v(k);
      r(";", !0);
    } else
      w && w(), r(";"), g && (typeof g.comment != "string" || u) && (g.comment = t(S) || g.comment);
  }
  function P(g, v) {
    if (!z.test(v = s()))
      throw d(v, "type name");
    var w = new et(v);
    F(w, function(k) {
      if (!J(w, k))
        switch (k) {
          case "map":
            mt(w);
            break;
          case "required":
          case "repeated":
            V(w, k);
            break;
          case "optional":
            m ? V(w, "proto3_optional") : V(w, "optional");
            break;
          case "oneof":
            vt(w, k);
            break;
          case "extensions":
            R(w.extensions || (w.extensions = []));
            break;
          case "reserved":
            R(w.reserved || (w.reserved = []), !0);
            break;
          default:
            if (!m || !Z.test(k))
              throw d(k);
            e(k), V(w, "optional");
            break;
        }
    }), g.add(w);
  }
  function V(g, v, w) {
    var S = s();
    if (S === "group") {
      yt(g, v);
      return;
    }
    for (; S.endsWith(".") || n().startsWith("."); )
      S += s();
    if (!Z.test(S))
      throw d(S, "type");
    var k = s();
    if (!z.test(k))
      throw d(k, "name");
    k = A(k), r("=");
    var T = new tt(k, I(s()), S, v, w);
    if (F(T, function(M) {
      if (M === "option")
        L(T, M), r(";");
      else
        throw d(M);
    }, function() {
      ne(T);
    }), v === "proto3_optional") {
      var $ = new rt("_" + k);
      T.setOption("proto3_optional", !0), $.add(T), g.add($);
    } else
      g.add(T);
    !m && T.repeated && (Se.packed[S] !== void 0 || Se.basic[S] === void 0) && T.setOption(
      "packed",
      !1,
      /* ifNotSet */
      !0
    );
  }
  function yt(g, v) {
    var w = s();
    if (!z.test(w))
      throw d(w, "name");
    var S = Re.lcFirst(w);
    w === S && (w = Re.ucFirst(w)), r("=");
    var k = I(s()), T = new et(w);
    T.group = !0;
    var $ = new tt(S, k, w, v);
    $.filename = W.filename, F(T, function(M) {
      switch (M) {
        case "option":
          L(T, M), r(";");
          break;
        case "required":
        case "repeated":
          V(T, M);
          break;
        case "optional":
          m ? V(T, "proto3_optional") : V(T, "optional");
          break;
        case "message":
          P(T, M);
          break;
        case "enum":
          $e(T, M);
          break;
        default:
          throw d(M);
      }
    }), g.add(T).add($);
  }
  function mt(g) {
    r("<");
    var v = s();
    if (Se.mapKey[v] === void 0)
      throw d(v, "type");
    r(",");
    var w = s();
    if (!Z.test(w))
      throw d(w, "type");
    r(">");
    var S = s();
    if (!z.test(S))
      throw d(S, "name");
    r("=");
    var k = new Wt(A(S), I(s()), v, w);
    F(k, function($) {
      if ($ === "option")
        L(k, $), r(";");
      else
        throw d($);
    }, function() {
      ne(k);
    }), g.add(k);
  }
  function vt(g, v) {
    if (!z.test(v = s()))
      throw d(v, "name");
    var w = new rt(A(v));
    F(w, function(k) {
      k === "option" ? (L(w, k), r(";")) : (e(k), V(w, "optional"));
    }), g.add(w);
  }
  function $e(g, v) {
    if (!z.test(v = s()))
      throw d(v, "name");
    var w = new Ht(v);
    F(w, function(k) {
      switch (k) {
        case "option":
          L(w, k), r(";");
          break;
        case "reserved":
          R(w.reserved || (w.reserved = []), !0);
          break;
        default:
          gt(w, k);
      }
    }), g.add(w);
  }
  function gt(g, v) {
    if (!z.test(v))
      throw d(v, "name");
    r("=");
    var w = I(s(), !0), S = {
      options: void 0
    };
    S.setOption = function(k, T) {
      this.options === void 0 && (this.options = {}), this.options[k] = T;
    }, F(S, function(T) {
      if (T === "option")
        L(S, T), r(";");
      else
        throw d(T);
    }, function() {
      ne(S);
    }), g.add(v, w, S.comment, S.options);
  }
  function L(g, v) {
    var w = r("(", !0);
    if (!Z.test(v = s()))
      throw d(v, "name");
    var S = v, k = S, T;
    w && (r(")"), S = "(" + S + ")", k = S, v = n(), sr.test(v) && (T = v.slice(1), S += v, s())), r("=");
    var $ = De(g, S);
    Ot(g, k, $, T);
  }
  function De(g, v) {
    if (r("{", !0)) {
      for (var w = {}; !r("}", !0); ) {
        if (!z.test(B = s()))
          throw d(B, "name");
        if (B === null)
          throw d(B, "end of input");
        var S, k = B;
        if (r(":", !0), n() === "{")
          S = De(g, v + "." + B);
        else if (n() === "[") {
          S = [];
          var T;
          if (r("[", !0)) {
            do
              T = b(), S.push(T);
            while (r(",", !0));
            r("]"), typeof T < "u" && se(g, v + "." + B, T);
          }
        } else
          S = b(), se(g, v + "." + B, S);
        var $ = w[k];
        $ && (S = [].concat($).concat(S)), w[k] = S, r(",", !0), r(";", !0);
      }
      return w;
    }
    var H = b();
    return se(g, v, H), H;
  }
  function se(g, v, w) {
    g.setOption && g.setOption(v, w);
  }
  function Ot(g, v, w, S) {
    g.setParsedOption && g.setParsedOption(v, w, S);
  }
  function ne(g) {
    if (r("[", !0)) {
      do
        L(g, "option");
      while (r(",", !0));
      r("]");
    }
    return g;
  }
  function wt(g, v) {
    if (!z.test(v = s()))
      throw d(v, "service name");
    var w = new Kt(v);
    F(w, function(k) {
      if (!J(w, k))
        if (k === "rpc")
          bt(w, k);
        else
          throw d(k);
    }), g.add(w);
  }
  function bt(g, v) {
    var w = t(), S = v;
    if (!z.test(v = s()))
      throw d(v, "name");
    var k = v, T, $, H, M;
    if (r("("), r("stream", !0) && ($ = !0), !Z.test(v = s()) || (T = v, r(")"), r("returns"), r("("), r("stream", !0) && (M = !0), !Z.test(v = s())))
      throw d(v);
    H = v, r(")");
    var ie = new Xt(k, S, T, H, $, M);
    ie.comment = w, F(ie, function(oe) {
      if (oe === "option")
        L(ie, oe), r(";");
      else
        throw d(oe);
    }), g.add(ie);
  }
  function At(g, v) {
    if (!Z.test(v = s()))
      throw d(v, "reference");
    var w = v;
    F(null, function(k) {
      switch (k) {
        case "required":
        case "repeated":
          V(g, k, w);
          break;
        case "optional":
          m ? V(g, "proto3_optional", w) : V(g, "optional", w);
          break;
        default:
          if (!m || !Z.test(k))
            throw d(k);
          e(k), V(g, "optional", w);
          break;
      }
    });
  }
  for (var B; (B = s()) !== null; )
    switch (B) {
      case "package":
        if (!o)
          throw d(B);
        C();
        break;
      case "import":
        if (!o)
          throw d(B);
        N();
        break;
      case "syntax":
        if (!o)
          throw d(B);
        q();
        break;
      case "option":
        L(x, B), r(";");
        break;
      default:
        if (J(x, B)) {
          o = !1;
          continue;
        }
        throw d(B);
    }
  return W.filename = null, {
    package: i,
    imports: c,
    weakImports: a,
    syntax: y,
    root: p
  };
}
var or = j, ar = /\/|\./;
function j(h, p) {
  ar.test(h) || (h = "google/protobuf/" + h + ".proto", p = { nested: { google: { nested: { protobuf: { nested: p } } } } }), j[h] = p;
}
j("any", {
  /**
   * Properties of a google.protobuf.Any message.
   * @interface IAny
   * @type {Object}
   * @property {string} [typeUrl]
   * @property {Uint8Array} [bytes]
   * @memberof common
   */
  Any: {
    fields: {
      type_url: {
        type: "string",
        id: 1
      },
      value: {
        type: "bytes",
        id: 2
      }
    }
  }
});
var pt;
j("duration", {
  /**
   * Properties of a google.protobuf.Duration message.
   * @interface IDuration
   * @type {Object}
   * @property {number|Long} [seconds]
   * @property {number} [nanos]
   * @memberof common
   */
  Duration: pt = {
    fields: {
      seconds: {
        type: "int64",
        id: 1
      },
      nanos: {
        type: "int32",
        id: 2
      }
    }
  }
});
j("timestamp", {
  /**
   * Properties of a google.protobuf.Timestamp message.
   * @interface ITimestamp
   * @type {Object}
   * @property {number|Long} [seconds]
   * @property {number} [nanos]
   * @memberof common
   */
  Timestamp: pt
});
j("empty", {
  /**
   * Properties of a google.protobuf.Empty message.
   * @interface IEmpty
   * @memberof common
   */
  Empty: {
    fields: {}
  }
});
j("struct", {
  /**
   * Properties of a google.protobuf.Struct message.
   * @interface IStruct
   * @type {Object}
   * @property {Object.<string,IValue>} [fields]
   * @memberof common
   */
  Struct: {
    fields: {
      fields: {
        keyType: "string",
        type: "Value",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.Value message.
   * @interface IValue
   * @type {Object}
   * @property {string} [kind]
   * @property {0} [nullValue]
   * @property {number} [numberValue]
   * @property {string} [stringValue]
   * @property {boolean} [boolValue]
   * @property {IStruct} [structValue]
   * @property {IListValue} [listValue]
   * @memberof common
   */
  Value: {
    oneofs: {
      kind: {
        oneof: [
          "nullValue",
          "numberValue",
          "stringValue",
          "boolValue",
          "structValue",
          "listValue"
        ]
      }
    },
    fields: {
      nullValue: {
        type: "NullValue",
        id: 1
      },
      numberValue: {
        type: "double",
        id: 2
      },
      stringValue: {
        type: "string",
        id: 3
      },
      boolValue: {
        type: "bool",
        id: 4
      },
      structValue: {
        type: "Struct",
        id: 5
      },
      listValue: {
        type: "ListValue",
        id: 6
      }
    }
  },
  NullValue: {
    values: {
      NULL_VALUE: 0
    }
  },
  /**
   * Properties of a google.protobuf.ListValue message.
   * @interface IListValue
   * @type {Object}
   * @property {Array.<IValue>} [values]
   * @memberof common
   */
  ListValue: {
    fields: {
      values: {
        rule: "repeated",
        type: "Value",
        id: 1
      }
    }
  }
});
j("wrappers", {
  /**
   * Properties of a google.protobuf.DoubleValue message.
   * @interface IDoubleValue
   * @type {Object}
   * @property {number} [value]
   * @memberof common
   */
  DoubleValue: {
    fields: {
      value: {
        type: "double",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.FloatValue message.
   * @interface IFloatValue
   * @type {Object}
   * @property {number} [value]
   * @memberof common
   */
  FloatValue: {
    fields: {
      value: {
        type: "float",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.Int64Value message.
   * @interface IInt64Value
   * @type {Object}
   * @property {number|Long} [value]
   * @memberof common
   */
  Int64Value: {
    fields: {
      value: {
        type: "int64",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.UInt64Value message.
   * @interface IUInt64Value
   * @type {Object}
   * @property {number|Long} [value]
   * @memberof common
   */
  UInt64Value: {
    fields: {
      value: {
        type: "uint64",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.Int32Value message.
   * @interface IInt32Value
   * @type {Object}
   * @property {number} [value]
   * @memberof common
   */
  Int32Value: {
    fields: {
      value: {
        type: "int32",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.UInt32Value message.
   * @interface IUInt32Value
   * @type {Object}
   * @property {number} [value]
   * @memberof common
   */
  UInt32Value: {
    fields: {
      value: {
        type: "uint32",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.BoolValue message.
   * @interface IBoolValue
   * @type {Object}
   * @property {boolean} [value]
   * @memberof common
   */
  BoolValue: {
    fields: {
      value: {
        type: "bool",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.StringValue message.
   * @interface IStringValue
   * @type {Object}
   * @property {string} [value]
   * @memberof common
   */
  StringValue: {
    fields: {
      value: {
        type: "string",
        id: 1
      }
    }
  },
  /**
   * Properties of a google.protobuf.BytesValue message.
   * @interface IBytesValue
   * @type {Object}
   * @property {Uint8Array} [value]
   * @memberof common
   */
  BytesValue: {
    fields: {
      value: {
        type: "bytes",
        id: 1
      }
    }
  }
});
j("field_mask", {
  /**
   * Properties of a google.protobuf.FieldMask message.
   * @interface IDoubleValue
   * @type {Object}
   * @property {number} [value]
   * @memberof common
   */
  FieldMask: {
    fields: {
      paths: {
        rule: "repeated",
        type: "string",
        id: 1
      }
    }
  }
});
j.get = function(p) {
  return j[p] || null;
};
var K = it.exports = Ct;
K.build = "full";
K.tokenize = dt;
K.parse = Ut;
K.common = or;
K.Root._configure(K.Type, K.parse, K.common);
var lr = it.exports;
export {
  lr as s
};
//# sourceMappingURL=index-Ch-rSMgZ.js.map
